import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { verifyMagicLink } from '../api/accountPortalClient.js';
import { phMagicLinkVerifyFailed } from '../utils/posthogEvents.js';

export default function VerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [error, setError] = useState('');
  const [confirming, setConfirming] = useState(false);

  const token = searchParams.get('token');

  async function handleConfirm() {
    setError('');
    setConfirming(true);
    try {
      const data = await verifyMagicLink(token);
      await signIn(data.accessToken);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err?.message || 'Invalid or expired link');
      phMagicLinkVerifyFailed({ reason: err?.message });
      setConfirming(false);
    }
  }

  return (
    <div className="page">
      <div className="card">
        <h1 className="logo">CODiii</h1>
        {!token ? (
          <>
            <div className="alert alert-error">Missing sign-in token.</div>
            <p className="subtitle">Request a new link from the login page.</p>
            <button className="btn" type="button" onClick={() => navigate('/login')}>
              Back to login
            </button>
          </>
        ) : error ? (
          <>
            <div className="alert alert-error">{error}</div>
            <p className="subtitle">Request a new link from the login page.</p>
            <button className="btn" type="button" onClick={() => navigate('/login')}>
              Back to login
            </button>
          </>
        ) : (
          <>
            <p className="subtitle">Click below to finish signing in.</p>
            <button className="btn" type="button" onClick={handleConfirm} disabled={confirming}>
              {confirming ? 'Signing in…' : 'Confirm sign-in'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
